<template>
  <div id="companies-index" class="mdl-grid">
      <mdl-select v-if="item.types.includes('select')"
        v-for="(item, index) in items"
        :item="item"
        :index="index"
        :changeEvent="changed"
        :key="item.id"></mdl-select>

      <progress-bar v-show="showProgress"></progress-bar>

      <mdl-card v-if="!showProgress && items[currentIndex].types.includes('card')"
        v-for="(data, i) in items[currentIndex].data"
        :i="i"
        :data="data"
        :index="currentIndex"
        :clickEvent="changed"
        :key="data.id"
        @showActionbar="actionbar = $event"></mdl-card>

        <!-- :points="points" -->
      <mdl-summary v-if="!showProgress && items[currentIndex].types.includes('summary')"
        :tree="tree"
        :data="items[currentIndex].data"
        :childData="items[currentIndex + 1].data"
        :index="currentIndex"
        :clickEvent="changed"
        @activeAudit="activeAudit = $event"
        @saveTree="$idb.keyVal.set('tree', undefined, $event)"
        @goBack="currentIndex += $event"></mdl-summary>

      <mdl-audit v-if="!showProgress && items[currentIndex].types.includes('audit')"
        :tree="tree"
        :data="items[currentIndex].data"
        :index="currentIndex"
        @activeAudit="activeAudit = $event"
        @goBack="currentIndex += $event"></mdl-audit>
  </div>
</template>

<script>
import Select from './Select'
import Card from './Card'
import Summary from './Summary'
import Audit from './Audit'
import Progress from '@/components/Shared/Progress/'

export default {
  components: {
    'mdl-select': Select,
    'mdl-card': Card,
    'mdl-summary': Summary,
    'mdl-audit': Audit,
    'progress-bar': Progress
  },
  data () {
    return {
      title: 'Auditoría',
      tree: { id: 1 },
      actionbar: {},
      activeAudit: false,
      currentIndex: 0,
      currentValue: 0,
      points: [],
      items: [
        {
          data: [],
          default: {
            fatherId: -1,
            name: 'Todas las Empresas',
            value: -1
          },
          id: 'empresas',
          loaded: [],
          resource: '/empresas',
          selected: {
            name: '',
            value: -1
          },
          types: ['select', 'card']
        },
        {
          data: [],
          default: {
            fatherId: -1,
            name: 'Todas las Unidades de Negocio',
            value: -1
          },
          id: 'unidades-negocio',
          loaded: [],
          resource: '/unidadesnegocio/empresa/',
          selected: {
            name: '',
            value: -1
          },
          types: ['select', 'card']
        },
        {
          data: [],
          default: {
            fatherId: -1,
            name: 'Todas los Inmuebles',
            value: -1
          },
          id: 'inmuebles',
          loaded: [],
          resource: '/inmuebles/unidadesnegocio/',
          selected: {
            name: '',
            value: -1
          },
          types: ['select', 'card']
        },
        {
          data: [],
          default: {
            fatherId: -1,
            name: 'Todas las Áreas a Evaluar',
            value: -1
          },
          id: 'areas',
          loaded: [],
          resource: '/areas/inmuebles/',
          selected: {
            name: '',
            value: -1
          },
          types: ['select', 'summary']
        },
        {
          data: [],
          default: {
            fatherId: -1,
            name: 'Todos los Rubros',
            value: -1
          },
          id: 'rubros',
          loaded: [],
          resource: '/rubros/areas/all/',
          selected: {
            name: '',
            value: -1
          },
          types: ['audit']
        },
        {
          data: [],
          default: {
            fatherId: -1,
            name: 'Todos las Especificaciones',
            value: -1
          },
          id: 'especificaciones',
          loaded: [],
          resource: '/especificaciones/rubros/',
          selected: {
            name: '',
            value: -1
          },
          types: []
        },
        {
          data: [],
          default: {
            fatherId: -1,
            name: 'Todos las Ponderaciones',
            value: -1
          },
          id: 'ponderaciones',
          loaded: [],
          resource: '/ponderaciones/especificaciones/',
          selected: {
            name: '',
            value: -1
          },
          types: []
        }
      ],
      showProgress: false
    }
  },
  watch: {
    title () {
      this.$title.show(this.title)
    },
    /* Active Audit Logic.
    activeAudit () {
      if (!this.activeAudit) {
        delete this.tree.inmueble
        delete this.tree.area
        this.$idb.keyVal.set('tree', undefined, this.tree)
      } else {
        this.tree.inmueble.activo = 1
        this.$idb.keyVal.set('inmuebles', undefined, this.tree.inmueble)
      }
    },*/
    currentIndex () {
      // console.log(this.currentIndex)
      // aplicamos el primer filto booleano efectivo para los select
      this.items.forEach( (item, index) => {
        item.data = index <= this.currentIndex ? item.data : [] // se muestran solo los true
        // aqui se redefine el valor del input (o select)
        item.selected.name = index >= this.currentIndex ? item.default.name : item.selected.name
        item.selected.value = index >= this.currentIndex ? item.default.value : item.selected.value
      })
    }
  },
  methods: {
    get () {},
    changed (event) {
      const self = this,
            element = event.currentTarget || event,
            value = 1 * element.dataset.value,
            i = 1 * element.dataset.i,
            index = 1 * element.dataset.index,
            item = this.items[index],
            fatherId = 1 * element.dataset.fatherId,
            data = item.data[i],
            name = data ? data.nombre : ( element.dataset.text || element.textContent ),
            // photo = element.dataset.photo,
            isDefault = !data
      let parent = {}, current = {}

      /* Active Audit Logic.
      if (this.activeAudit && !item.id.match(/areas|rubros/)) {
        return this.$toast.show('Favor de CANCELAR auditoría para regresar.')
      }*/

      this.$actionbar.destroy()
      // Armando el arbol de navegacion.
      switch (item.id) {
        case 'empresas':
          this.tree.empresa = data
          break
        case 'unidades-negocio':
          this.tree.unidadNegocio = data
          break
        case 'inmuebles':
          if (!isDefault) {
            data.incidencias = 0
            data.promedio = 0
            data.resumen = ''
          }
          this.tree.inmueble = data
          break
        case 'areas':
          this.tree.area = data
          break
      }

      this.$idb.keyVal.set('tree', undefined, this.tree)

      // Cambiar el value al select (en realidad es un input)
      this.items[index].selected.name = name
      this.title = name
      // Si se eligio el default (todos), el index es del mismo select,
      // si no, es el select hijo (o siguiente).
      this.currentIndex = isDefault ? index : index + 1
      parent.item = this.items[this.currentIndex - 1]
      current.item = this.items[this.currentIndex]
      // Se define el fatherId del item elegido, para comparar ese id
      // con el fatherId de cada elemento ya cargado,
      // y asi solo mostrar los que coincidan.
      current.item.default.fatherId = isDefault ? current.item.default.fatherId : value
      // es el value que se usara para obtener los recursos.
      this.currentValue = isDefault ? fatherId : value
      this.items[index].selected.value = value

      /* Definiendo funcion para realizar refresh */
      this.get = () => {
        const currentItem  = self.items[self.currentIndex]
        const currentValue = currentItem.default.fatherId
        const endpoint = currentValue === -1
          ? currentItem.resource
          : currentItem.resource + currentValue

        self.showProgress = true
        self.$http.get(endpoint)
          .then(response => {
            let data = response.data

            self.$idb.keyVal.deleteOnly(currentItem.id, 'padreId', currentValue)
              .then(deletedCount => {
                const promises = []
                // Loop para agregar propiedades que solo se usaran en front.
                data.forEach(d => {
                  switch (currentItem.id) {
                    case 'inmuebles':
                      d.activo = 0
                      d.puntos = 0
                      d.promedio = 0
                      // d.mantenimiento = d.mantenimiento
                      //   ? JSON.parse(d.mantenimiento)
                      //   : {}
                      break

                    case 'areas':
                      d.puntos = 0
                      d.promedio = 0
                      break

                    case 'rubros':
                      d.puntos = 0
                      d.promedio = 0
                      d.especificaciones.forEach(especificacion => {
                        especificacion.imagenes = []
                        especificacion.selected = {
                          id: especificacion.ponderaciones[0].id,
                          color: especificacion.ponderaciones[0].color,
                          valor: especificacion.ponderaciones[0].valor
                        }
                        especificacion.observaciones = ''
                      })
                      break
                  }

                  promises.push(self.$idb.keyVal.set(currentItem.id, undefined, d))
                })

                Promise.all(promises).then(() => {
                  currentItem.data = data
                  self.showProgress = false
                }, ()=> {
                  self.$toast.show('¡Algo sucedió! Porfavor vuelve a realizar la misma operación.')
                })
              })
          }).catch(error => {
            self.$toast.show('No fue posible obtener la información del servidor.')
            self.showProgress = false
          })
      }

      this.$endpoint.refresh(this.get)
      /* fin */

      // Evaluar si ya existe en IDB.
      this.$idb.keyVal.getOnly(current.item.id, 'padreId', this.currentValue)
        .then(data => {
          if (data.length > 0) {
            return current.item.data = data
          }

          self.get()
        })
        .catch(error => { console.log(error) })
    }
  },
  mounted () {
    let item = this.items[this.currentIndex]

    // Revisar si hay una auditoria activa.
    this.$idb.keyVal.getOnly('inmuebles', 'activo', 1).then(data => {

      if (data.length > 0) {
        let inmueble = data[0]

        this.$idb.keyVal.get('tree', 1).then(tree => {
          let promises = []

          this.tree = tree
          this.items[0].selected.name = tree.empresa.nombre
          this.items[0].selected.value = tree.empresa.id
          this.items[1].selected.name = tree.unidadNegocio.nombre
          this.items[1].selected.value = tree.unidadNegocio.id
          this.items[1].default.fatherId = tree.unidadNegocio.padreId
          this.items[2].selected.name = tree.inmueble.nombre
          this.items[2].selected.value = tree.inmueble.id
          this.items[2].default.fatherId = tree.inmueble.padreId
          this.items[3].default.fatherId = tree.inmueble.id
          this.title = tree.inmueble.nombre
          /* Active Audit Logic: this.activeAudit = true*/

          promises.push(this.$idb.keyVal.getOnly('empresas', 'padreId', tree.empresa.padreId)
            .then(empresas => {
              this.items[0].data = empresas
            })
          )

          promises.push(this.$idb.keyVal.getOnly('unidades-negocio', 'padreId', tree.unidadNegocio.padreId)
            .then(unidadesNegocios => {
              this.items[1].data = unidadesNegocios
            })
          )

          promises.push(this.$idb.keyVal.getOnly('inmuebles', 'padreId', tree.inmueble.padreId)
            .then(inmuebles => {
              this.items[2].data = inmuebles
            })
          )

          promises.push(this.$idb.keyVal.getOnly('areas', 'padreId', tree.inmueble.id)
            .then(areas => {
              this.items[3].data = areas
            })
          )

          promises.push(this.$idb.keyVal.getOnly('rubros', 'padreId', tree.area.id)
            .then(rubros => {
              this.items[4].data = rubros
            })
          )

          Promise.all(promises).then(() => {
            this.currentIndex = 3
          })
        })

        return
      }

      this.$idb.keyVal.getAll(item.id)
        .then(data => {
          if (data.length > 0) {
            return item.data = data
          }

          this.get()
        })
        .catch(error => { console.log(error) })
    })

    this.get = () => {
      this.showProgress = true
      return this.$http.get(item.resource)
        .then(response => {
          const data = response.data

          data.forEach(d => {
            this.$idb.keyVal.set(item.id, undefined, d)
          })

          item.data = data
          this.showProgress = false
        }).catch(error => {
          this.$toast.show('No fue posible obtener la información del servidor.')
          this.showProgress = false
        })
    }
    this.$endpoint.refresh(this.get)

    // Cambiando el titulo.
    this.$title.show(this.title)
    this.$actionbar.destroy()
  }
}
</script>

<style lang="css" scoped>
  .mdl-selectfield {
    margin-right: 1rem;
  }
</style>


// WEBPACK FOOTER //
// index.vue?53c453e4